import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DatatableClickEvent } from '@basis/angular-components';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SelectItem, FileUpload } from 'primeng/primeng';
import { BaseStepComponent } from '../../../base/base-step.component';
import { PrestarConta } from '../../../entity/prestar-conta';
import { Justificar } from '../../../entity/justificar';
import { PrestarContaInstrutor } from '../../../entity/prestar-conta-instrutor';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'curso-prestacao-conta-etapa1',
  templateUrl: './curso-prestacao-conta-etapa1.component.html',
})
export class CrudCursoPrestacaoContaEtapa1Component extends BaseStepComponent {
  @Input() listaConteudo: any[] = [];
  @Input() listaInstrutorCargaHoraria: any[] = [];
  @Output() listaInstrutorCargaHorariaChange = new EventEmitter<any>();

  @Input() listaCursoInstrutores: any[] = [];
  @Input() validateForm: any = false;
  @Output() validateFormChange = new EventEmitter<any>();
  @Input() listaParticipantes: any[] = [];
  @Output() listaParticipantesChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() turmaSelecionada = 0;

  @Input() modalTermoAceiteLGPD: any = false;

  @Output() stepObject: EventEmitter<any> = new EventEmitter<any>(true);

  displayIntrutorModal = false;
  displayPrestarContaModal = false;
  displayJustificarModal = false;
  emLote = false;
  instrucao: any[];

  prestar_conta: PrestarConta = new PrestarConta;
  justificar: Justificar = new Justificar;
  prestar_conta_instrutor: PrestarContaInstrutor = new PrestarContaInstrutor;
  modal_obj: any;
  form_prestacao_conta = null;
  form_justificar = null;

  listaSelectParticipantes: any[] = [];

  valor: any = {};



  init() {
    this.form_prestacao_conta = this.formBuilder.group({
      id_instrutor: [null, [Validators.required]],
      carga_horaria: [null, [Validators.required]]
    });
    this.form_justificar = this.formBuilder.group({
      id: [null],
      justificativa: [null]
    });

    this.cadastro.get('participantes.tipo_inclusao').valueChanges.subscribe(item => {
      if (item === '2') {
        this.emLote = false;
      }
      if (item === '1') {
        this.emLote = true;
      }
    });
  }
  addList(event: any) {
    const cpf = this.limpaCaracterEspecial(this.cadastro.get('participantes.cpf').value)
    this.cadastro.get('participantes.cpf').setValue(cpf)
    this.addToList(this.listaParticipantes, this.listaParticipantesChange, this.cadastro.get('participantes') as FormGroup, event, { cpf: cpf })
  }
  AddListaInstrutor(form_prestacao_conta: FormGroup, event: any) {
    let valorCargaHorariaLista = 0
    this.listaInstrutorCargaHoraria.forEach(x => {
      valorCargaHorariaLista += x.carga_horaria;
    })

    const soma = valorCargaHorariaLista + form_prestacao_conta.get('carga_horaria').value;

    const valido = soma > this.modal_obj.curso.carga_horaria ? false : true;

    if (valido) {
      this.addToList(this.listaInstrutorCargaHoraria, this.listaInstrutorCargaHorariaChange, form_prestacao_conta, event, { id_instrutor: form_prestacao_conta.get('id_instrutor').value })
    } else {
      form_prestacao_conta.get('carga_horaria').setErrors({ error: 'Carga horária superior a do curso.' })
    }
  }

  removerParticipantes() {
    this.listaSelectParticipantes.forEach(x => {
      this.listaParticipantes = this.listaParticipantes.filter(y => y.cpf != x.cpf);
    })
    this.listaParticipantesChange.emit(this.listaParticipantes);
  }

  salvarPrestacaoConta() {
    this.prestar_conta.conteudo = null;
    this.prestar_conta.turma = null;
    this.prestar_conta.prestacao_conta_instrutor = [];
    this.listaInstrutorCargaHoraria.forEach(
      item => {
        item.id = 0;
        item.instrutor = null;
        item.prestar_conta = null;
        this.prestar_conta.prestacao_conta_instrutor.push(item)
      });
    this.prestar_conta.id_turma = this.turmaSelecionada;
    this.observableUtilPanelDoc.setBlockedPanel(true);
    this.service.Adicionar('prestarConta', this.prestar_conta).subscribe(sucess => {
      this.dysplayModal(1);
      super.showMsgSucess('Registro salvo com sucesso.')
      this.observableUtilPanelDoc.setBlockedPanel(false);
    },
      err => {
        super.showMsgWarn(`${err._body}`);
        this.observableUtilPanelDoc.setBlockedPanel(false);
      }
    );
  }
  salvarJustificar() {
    this.justificar.id_turma = this.turmaSelecionada;
    this.justificar.justificativa = this.form_justificar.get('justificativa').value;
    this.justificar.id = this.form_justificar.get('id').value;
    this.observableUtilPanelDoc.setBlockedPanel(true);
    this.service.Adicionar('justificar', this.justificar).subscribe(sucess => {
      this.atualizarJustificativaConteudo();
      this.dysplayModal(2);
      super.showMsgSucess('Registro salvo com sucesso.');
      this.observableUtilPanelDoc.setBlockedPanel(false);

    }, err => {
      this.observableUtilPanelDoc.setBlockedPanel(false);
      super.showMsgError(`Erro ao Gravar. ${err._body}`)
    });
  }

  atualizarJustificativaConteudo() {
    const obj = this.listaConteudo.find(x => x.id === this.justificar.id_conteudo);
    const indice = this.listaConteudo.indexOf(obj);
    obj.justificar[0] = this.justificar;
    this.listaConteudo.splice(indice, 1, obj);
  }

  dysplayModal(modal: number, obj: any = null) {
    if (modal === 1) {
      this.displayPrestarContaModal = !this.displayPrestarContaModal;
      if (obj != null) {
        this.prestar_conta.id_conteudo = obj.id;
        this.modal_obj = obj;
        if (obj.prestar_conta[0] != null) {
          this.prestar_conta = obj.prestar_conta[0];
          this.listaInstrutorCargaHoraria = obj.prestar_conta[0].prestacao_conta_instrutor;
        }
      }
    }

    if (modal === 2) {
      this.displayJustificarModal = !this.displayJustificarModal;
      if (obj != null) {
        this.justificar.id_conteudo = obj.id;
        if (obj.justificar != null) {
          this.form_justificar.patchValue(obj.justificar[0]);
        }
      }
    }
  }

  dysplayAnexo(btnclick: number) {
    if (btnclick == 1) {
      this.displayIntrutorModal = true;
      this.instrucao = [];
      this.instrucao.push('<strong>1. Utilize o modelo correto:</strong>');
      this.instrucao.push('\tBaixe o modelo padrão clicando no botão "Documento" ao lado de "Instrução";');

      this.instrucao.push('<strong>2. Preencha os dados em uma única coluna:</strong>');
      this.instrucao.push('\tInsira o nome completo do participante, seguido de vírgula (,) e o CPF (11 números) no formato 000.000.000-00 ou 00000000000;');
      this.instrucao.push('\t<strong>Exemplo:</strong>João da Silva,000.000.000-00;');

      this.instrucao.push('<strong>3. Atenção ao preencher:</strong>');
      this.instrucao.push('\t<strong>Comece na linha 2:</strong> A primeira linha é reservada para os títulos das colunas');
      this.instrucao.push('\t<strong>Nome:</strong> Não utilize caracteres especiais como: @, #, $, %, &, *, (, ), !, ?, +, =, etc');
      this.instrucao.push('\t<strong>CPF:</strong> Preencha com todos os 11 números, utilizando um dos dois modelos citados acima');

      this.instrucao.push('<strong>4. Revise antes de enviar:</strong>');
      this.instrucao.push('\tVerifique atentamente todos os dados. Qualquer erro impedirá o processamento');
      
      this.instrucao.push('<strong>5. Salve o arquivo:</strong>');
      this.instrucao.push('\tSalve a planilha no formato CSV UTF-8');
    } else {
      this.service.ObterDocumento(`arquivo/documentoEvento`).subscribe(
        data => {
          FileSaver.saveAs(this.b64toFile(data, null, 'application/octet-stream'), 'Participantes_Lote.csv');
          this.showMsgSucess(`O arquivo Participantes_Lote.csv foi baixado automaticamente, verifique na pasta de downloads.`);
        }
        , err => this.showMsgError(`Houve um erro ao baixar o arquivo. ${err._body}`)
      )
    }
  }

  uploadArquivoLote(event) {
    for (const file of event.files) {
      if (file.size < 10000000) {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = event => {
          this.valor = {
            filename: file.name,
            filetype: file.type,
            value: fileReader.result.split(',')[1],
            id_prestar_conta: this.turmaSelecionada
          }
          this.service.UploadExcel('participantes', this.valor).subscribe(data => {
            data.forEach(element => {
              const existe = this.listaParticipantes.find(x => x.cpf == this.limpaCaracterEspecial(element.cpf) ||
                x.cpf == element.cpf);
              if (existe == null) {
                element.cpf = this.limpaCaracterEspecial(element.cpf);
                this.listaParticipantes.push(element);
              }
            });
            this.listaParticipantes = [... this.listaParticipantes];
            this.listaParticipantesChange.emit(this.listaParticipantes);
          },
            err => {
              this.showMsg('error', 'Mensagem de Erro', `${err._body}`)
            });
        };
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/curso-prestacao-conta/crud/etapas/curso-prestacao-conta-etapa1.component.ts